import { color } from '@upstox/upstox-ui';

export const oiBarCell: CSSFunction<{
  isCall: boolean;
  width: number;
}> = ({ theme, cssProps }) => {
  const { isCall, width } = cssProps;

  return {
    position: 'absolute',
    display: 'inline-block',
    bottom: 0,
    ...(isCall ? { right: 0 } : { left: 0 }),
    height: 4,
    backgroundColor: color(theme, theme.colors.data.yellow),
    transition: 'width 0.1s',
    width,
  };
};
